import cx from 'classnames';
import { ContentContainer } from 'themes/organic/components/ContentContainer';
import { CtaButton, Service, Subtitle } from 'themes/organic/components/index';

import { ServiceOptionsModal } from 'routes/services/ServiceOptionsModal';

import type { TService } from 'types/service';

import s from './Services.module.css';

export interface ServicesProps {
  className?: string;
  onServiceClick: (guid: string) => void;
  services: TService[];
  href: string;
  pendingSelectService?: TService;
  onSelectServiceOption: (
    id: string,
    optionId: string,
    bookingOrder?: number,
  ) => void;
  onCloseServiceOption: () => void;
}

const Services = ({
  onServiceClick,
  services,
  className,
  href,
  pendingSelectService,
  onSelectServiceOption,
  onCloseServiceOption,
}: ServicesProps) => {
  return (
    <section className={cx(s.root, className)}>
      <ContentContainer>
        <Subtitle>Services</Subtitle>
        <div className={s.serviceList}>
          {services.slice(0, 3).map((service) => (
            <article key={service.guid} className={s.serviceItem}>
              <Service
                service={service}
                ctaText="Book Now"
                onClick={onServiceClick}
              />
            </article>
          ))}
        </div>
        <ServiceOptionsModal
          service={pendingSelectService}
          onSelect={onSelectServiceOption}
          onClose={onCloseServiceOption}
        />
        <div className={s.viewMoreContainer}>
          <CtaButton href={href} style={2} title="All Services">
            all services
          </CtaButton>
        </div>
      </ContentContainer>
    </section>
  );
};

export { Services };
